import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { AbstractFormComponent } from '../abstract-form.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscription } from 'rxjs';
import { AppConfiguration } from '../../../core/models/app-configuration.model';
/**
 * Verification Code Form Component
 * @description Angular Utility Component. Show the verification code submition form
 */
@Component({
  selector: 'ap-modal-verification-code-form',
  templateUrl: './verification-code-form.component.html',
  styles: ['.form-group .col p {line-height: 15px; font-size: 14px;}'],
})
export class VerificationCodeFormComponent extends AbstractFormComponent implements OnInit, OnDestroy {
  @Input() descriptionText?: string;

  /** hide/show request new code link */
  @Input() disableRequestNewCode?: boolean;

  @Input() verifyCodeLabelText?: string;
  @Input() requestNewCodeText?: string;
  @Input() requestNewCodeLinkText?: string;
  @Input() submitButtonText?: string;
  @Input() backButtonTxt?: string;
  @Input() linkSmsText?: string;
  @Input() descLinkSmsText?: string;
  @Input() modificaloButtonTxt?: string;

  @Input() serialNumberView?: boolean;

  /** hide/show modificalo new link */
  @Input() disableModifica?: boolean;

  @Input() events?: Observable<boolean>;
  eventsSubscription: Subscription | undefined;
  eventsFocus: Subject<boolean> = new Subject<boolean>();
  showError = false;

  @Output() onVerificationCodeSubmitted = new EventEmitter<string>();
  @Output() onGoBackClicked = new EventEmitter<void>();
  @Output() onNewCodeRequestClicked = new EventEmitter<void>();
  @Output() onSelectedRetryMethodClicked = new EventEmitter<void>();

  urlModifica = '';
  codeForm = this.fb.group({
    code: [''],
  });



  constructor(private readonly fb: UntypedFormBuilder, protected ngxSpinner: NgxSpinnerService, private readonly appConfig: AppConfiguration) {
    super(ngxSpinner);
  }
  ngOnDestroy(): void {
    this.eventsSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    /* tslint:disable:typedef */
    this.eventsSubscription = this.events?.subscribe(() => {
      this.eventsFocus.next(true);
    });

    this.urlModifica = this.appConfig.changeContact;
  }

  /**
   * @ignore
   */
  getSpinnerName(): string {
    return 'verifyCodeBtn';
  }

  /**
   * When user submit the form, send code to subscribers
   */
  submitCode(): void {
    const code = this.codeForm.get('code')?.value || '';
    this.onVerificationCodeSubmitted.next(code);
  }

  /**
   * Method invoked when user ask for new code.
   * Send information to subscribers
   */
  requestNewVerificationCode(): void {
    const codeControl = this.codeForm.get('code');
    if (codeControl) {
      codeControl.setErrors({ ...codeControl.errors, serverError: null });
      codeControl.updateValueAndValidity();
    }

    this.onNewCodeRequestClicked.next();
  }

  /**
   * Method invoked when user ask to go back (if this component is inside a multistep form) or dismiss current modal
   */
  goBack(): void {
    this.onGoBackClicked.next();
  }

  /**
   * Method invoked when user ask to  (if this component is inside a multistep form) or dismiss current modal
   */
  selectedRetryMethod(): void {
    this.onSelectedRetryMethodClicked.next();
  }
}
